import { render } from "./comment-card.vue?vue&type=template&id=1ff9575e&scoped=true"
import script from "./comment-card.vue?vue&type=script&lang=js"
export * from "./comment-card.vue?vue&type=script&lang=js"

import "./comment-card.vue?vue&type=style&index=0&id=1ff9575e&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff9575e"]])

export default __exports__